module.exports = __webpack_public_path__ + "media/images/countrysquared/bz-f85ca3d515eb7efce5aec7095514bb35.svg";